module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-08.0124951d.jpg";